/**
 * Merkezi renk sözlüğü — UI’da `var(--flow-*)` ile çalışır; JWT shell overrides ile uyumlu.
 *
 * Envanter (kabaca): client/src içinde ~39 benzersiz #hex (MJPEG paleti, gradientler dahil)
 * ve çoğunlukla tekrarlayan birkaç rgba (form yüzeyi, border, danger).
 *
 * İsimlendirme: tek önek `flow.*` — Tailwind `text-flow-accent`, JS `FLOW_VAR.accent`.
 */

/** CSS custom properties — inline style / react-select için */
export const FLOW_VAR = {
  text: "var(--flow-text, #26273b)",
  textMuted: "var(--flow-text-muted, #acadc1)",
  accent: "var(--flow-accent, #ccb17b)",
  accentHover: "var(--flow-accent-hover, #bc9553)",
  accentMutedSurface: "var(--flow-accent-muted, #f0f0f5)",
  borderAccent: "var(--flow-border-accent, #ccb17b)",
  borderAccentHover: "var(--flow-border-accent-hover, #bc9553)",
  buttonOnAccent: "var(--flow-button-text, #fcfcfd)",
  surface: "var(--flow-surface)",
  surfaceSelected: "var(--flow-surface-selected)",
  surfaceSelectedSoft: "var(--flow-surface-selected-soft)",
  border: "var(--flow-border)",
  borderHover: "var(--flow-border-hover)",
  borderDisabled: "var(--flow-border-disabled)",
  danger: "var(--flow-danger)",
  success: "var(--flow-success)",
  overlayInk: "var(--flow-overlay-ink)",
  shellTint: "var(--flow-shell-tint)",
};

/** Gölgeler — tam string (react-select menu, kamera vignette) */
export const FLOW_SHADOW = {
  menu: "var(--flow-shadow-menu)",
  vignettePhone: "var(--flow-shadow-vignette-phone)",
  vignettePhoneWide: "var(--flow-shadow-vignette-phone-wide)",
};

/**
 * Plato fallback hex — tema yokken veya canvas’ta `getComputedStyle` olmadan.
 * İnsan okuması; mümkün olduğunca `FLOW_VAR` tercih edin.
 */
export const FLOW_HEX = {
  ink: "#26273b",
  inkSecondary: "#454560",
  muted: "#acadc1",
  accent: "#ccb17b",
  accentHover: "#bc9553",
  surface: "#f9fafb",
  surfaceSelected: "#e5e7eb",
  border: "#e5e7eb",
  danger: "#dc2626",
  success: "#77dd77",
  overlayInk: "#26273b",
  white: "#ffffff",
  /** SVG guide ring — hazır değilken nötr gri */
  ringNeutral: "#666666",
};
